<template>
  <div v-if="!isEnthusiastMember">
    <div class="make-request make-request--inside-data-filter">
      <div class="make-request__inner">
        <p class="make-request__title">Can't find your destination?</p>
        <p class="make-request__text">Let us know where you are going and we'll create a bespoke itinerary for you</p>
        <button class="border-btn btn make-request__btn" type="button" @click="handleOpenLiaisonModal">
          Request bespoke itinerary
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMakeItineraryRequest',

  data() {
    return {
      liaison: null,
    };
  },

  computed: {
    isEnthusiastMember() {
      return !!this.$store.state.museumRole;
    },
    isMobileScreen() {
      return !!this.$store.state.isMobileScreen;
    },
  },

  methods: {
    async handleOpenLiaisonModal() {
      this.$store.dispatch('memberLiaisonModal/toggleModal', true);
    },
  },
};
</script>
